import React,{useEffect} from 'react'
import clsx from 'clsx'
function Paginate({position="start",pageNumbers,paginate,currentPage}) {
 // console.log("In pagination")
   //console.log(currentPage);
   //console.log(pageNumbers);
   //console.log(paginate);
  return (
    <>
    {pageNumbers&&
       <nav>
            <ul className={clsx('pagination',{
                'justify-content-start': position === 'start',
                'justify-content-center': position === 'center',
                'justify-content-end': position === 'end',
            }
            )}>
            {pageNumbers.map(number => (
              <li key={number} className={`page-item ${currentPage === number -1 ? 'active' : ''}`}>
                <button className="page-link" onClick={()=>paginate(number -1)}>
                {number}
                </button>
                
              </li>
            ))}
            </ul>
       </nav>
    }
    </>
  )
}

export default Paginate